const DATE_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const TIME_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  hour: "2-digit",
  minute: "2-digit",
});

/**
 * Data e hora do evento em partes: a listagem empilha as duas na coluna
 * Data/Hora e o detalhamento as apresenta na mesma linha. Sem data válida, o
 * texto devolvido pelo serviço vai em `date` e a hora fica vazia.
 */
export function formatAuditDateTime(value: string): { date: string; time: string } {
  const timestamp = Date.parse(value);
  if (Number.isNaN(timestamp)) return { date: value, time: "" };

  const moment = new Date(timestamp);

  return { date: DATE_FORMATTER.format(moment), time: TIME_FORMATTER.format(moment) };
}
